module.exports = __webpack_public_path__ + "static/media/icon-cookies.2d178e4c.svg";